import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { doctorProfileRequestState } from '../../services/data.searvice';
import { Image } from "../../components/componentIndex";
import { useRecoilState } from "recoil";
import MarkLocationIcon from '../../assets/images/doctorProfile/map-marker.svg';
import DatePicker from "react-datepicker";
import CloseIcon from '../../assets/images/doctorProfile/close-icon.svg';
import PatientService from 'services/API/patientService';
import VisitService from 'services/API/visitService';
import 'react-datepicker/dist/react-datepicker.css';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import { toast } from "react-toastify";

const AppointmentSchedule = ({ appointmentData, closeFullScreen }) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); // Get the search parameters
    let today = appointmentData?.appointmentDate ? new Date(appointmentData?.appointmentDate) : new Date();
    const [calenderValue, setCalenderValue] = useState();
    const [selectedTime, setSelectedTime] = useState({ location: '', time: '' });
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isAddressTime, setIsAddressTime] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userId, setUserId] = useState(appointmentData?.fkUserId || null);
    const [doctorAvailability, setDoctorAvailability] = useState({});
    const [notAvailableDate, setNotAvailableDate] = useState([]);
    const [doctorProfileRequest, setDoctorProfileRequest] = useRecoilState(doctorProfileRequestState);
    const { state: data } = useAuthenticationContext();
    const [isChangeMonth, setIsChangeMonth] = useState(false);
    const [selectedDate, setSelectedDate] = useState();
    const [highlightedDates, setHighlightedDates] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    const calenderOnChange = (date) => {
        setIsChangeMonth(false);
        setCalenderValue(date);
        setSelectedDate(date);
        setIsAddressTime(true);
        getDoctorAvailability(date);
    };

    // const handleMonthChange = (date) => {
    //     setDoctorAvailability({});
    //     const firstDateOfMonth = getFirstDateOfMonth(date); // Reset to the previous month
    //     setCalenderValue(firstDateOfMonth);
    //     getNotAvailableDates(firstDateOfMonth);
    // }

    const handleMonthChange = (event, date) => {
        event.preventDefault(); // Simulated preventDefault()
        const selectedFindDate = date?.getMonth() === today?.getMonth() ? today : getFirstDateOfMonth(date);
        // const findSearchParamDate = new Date(searchParams.get('date'));
        // if (date?.getMonth() !== today?.getMonth() && date?.getMonth() !== findSearchParamDate.getMonth()) {
        //     setIsChangeMonth(true);
        // }
        if (date?.getMonth() !== today?.getMonth()) {
            setIsChangeMonth(true);
        }
        setCalenderValue(selectedFindDate);
        getNotAvailableDates(selectedFindDate);
    }

    const getFirstDateOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1);
    };

    useEffect(() => {
        setCalenderValue(null);
        // setCalenderValue(new Date(appointmentData?.appointmentDate));
        setUserId(appointmentData?.fkUserId);
        getNotAvailableDates(null);
        setHighlightedDates([new Date(appointmentData?.appointmentDate)]);
    }, []);

    const convertDate = (dateString) => {
        const date = new Date(dateString); // Parse the date string
        // Get the parts of the date
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, "0");
        // Format as 'YYYY/MM/DD'
        return `${year}/${month}/${day}`;
    };

    const getDoctorAvailability = async (date) => {
        try {
            let formattedDate = '';
            formattedDate = convertDate(date);
            let requestObject = {
                fkUserId: userId || appointmentData?.fkUserId,
                date: formattedDate
            }
            setSelectedTime({ location: '', time: '' });
            setIsLoading(true);
            const response = await PatientService.getDoctorAvailability(requestObject);
            if (response?.statusCode === 200) {
                setDoctorAvailability(response?.result);
            }
            setIsLoading(false);
            return response;
        } catch (error) {
            setIsLoading(false);
            console.error("Login failed: ", error);
        }
    }
    const getNotAvailableDates = async (monthFirstDate) => {
        try {
            let findDate = monthFirstDate ? monthFirstDate : calenderValue || appointmentData?.appointmentDate
            let formattedDate = convertDate(findDate);

            let requestObject = {
                fkUserId: userId || appointmentData?.fkUserId,
                date: formattedDate //calenderValue?.toLocaleDateString() || searchParams.get('date')
            }
            const response = await PatientService.getNotAvailableDates(requestObject);
            if (response?.statusCode === 200) {
                setNotAvailableDate(response?.result);
            }
            return response;
        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    // Function to add custom class to disabled days
    const dayClassName = (date) => {
        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();

        // Add class if date is before today and it's not today itself
        if (date < today && !isToday) {
            return 'disabled-before-today'; // Class for days before today
        }

        return ''; // No class for valid days and today itself
    };

    const reScheduleVisit = async (time) => {
        if(!time){
            return;
        }
        let selectedTimes = doctorAvailability?.availableSlots?.map((center) => center?.slots?.find((slot) => slot?.startTime === time)).find(Boolean);;
        try {
            const date = new Date(calenderValue);
            // Extract only the date in YYYY-MM-DD format
            const formattedDate = date?.toISOString()?.slice(0, 10);
            let requestObject = {
                "visitId": appointmentData?.fkVisitId,
                "appointmentDate": formattedDate,
                "startTime": selectedTimes?.startTime,
                "endTime": selectedTimes?.endTime,
                "roomId": selectedTimes?.roomId
            }
            if(!selectedTimes?.startTime || !selectedTimes?.endTime || !selectedTimes?.roomId){
                setErrorMessage('Please select available slots');
                return;
            }else{
                setErrorMessage(null);
            }
            const accessToken = data?.userData?.result?.token;
            if (accessToken) {
                const response = await VisitService.reScheduleVisit(requestObject, accessToken);
                if (response?.statusCode === 200) {
                    navigate('/landing');
                } else {
                    toast.error(response?.message);
                }
                return response;
            }

        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    const handleSelectTime = (location, time) => {
        setSelectedTime({ location, time });
        reScheduleVisit(time);
        setIsAddressTime(false);
        closeFullScreen();
    };

    // Parse the date strings into Date objects
    const disabledDates = notAvailableDate?.map((date) => new Date(date));

    // Filter function to disable specific dates
    const isDateDisabled = (date) => {
        return disabledDates.some(
            (disabledDate) =>
                disabledDate.getFullYear() === date.getFullYear() &&
                disabledDate.getMonth() === date.getMonth() &&
                disabledDate.getDate() === date.getDate()
        );
    };

    const checkDate = (calenderValue) => {
        let targetDate = calenderValue ? new Date(calenderValue).toISOString()?.split('.')[0] : null;
        if (targetDate) {
            const exists = notAvailableDate?.map(date => date === targetDate)?.includes(true);
            return exists;
        } else {
            return false;
        }
    }

    return (
        <>
            <div className="custom-container doctor-profile-content">
                <div className="fullscreen-overlay">
                    <div className="fullscreen-overlay-content reschedule-overlay-content">
                        <button className="close-button circle-btn" onClick={handleSelectTime}>
                            <Image imgUrl={CloseIcon} altText={'close'} className={''} />
                        </button>
                        <h2 className="calendar-title mb-0">Choose a day and time</h2>
                        <div className="calendar-container doctor-profile margin-y-50 my-0">
                            {/* <DatePicker
                                onChange={(date) => calenderOnChange(date)}
                                selected={checkDate(calenderValue) ? '' : calenderValue}
                                inline
                                filterDate={(date) => !isDateDisabled(date)} // Disable specific dates
                                dayClassName={dayClassName} //
                                calendarStartDay={0}
                                locale="it"
                                onMonthChange={(date) => handleMonthChange(date)}
                                minDate={new Date()}
                            /> */}
                            <DatePicker
                                                            onChange={(date) => calenderOnChange(date)}
                                                            selected={isChangeMonth ? checkDate(selectedDate) ? '' : selectedDate : checkDate(calenderValue) ? '' : calenderValue}
                                                            inline
                                                            filterDate={(date) => !isDateDisabled(date)} // Disable specific dates
                                                            dayClassName={dayClassName} //
                                                            highlightDates={highlightedDates}
                                                            // highlightDates={selectedDate ? [] : checkHighLightDates(highlightedDates)}
                                                            calendarStartDay={0}
                                                            locale="it"
                                                            onMonthChange={(date) => {
                                                                const fakeEvent = { preventDefault: () => console.log("Prevented default action") };
                                                                handleMonthChange(fakeEvent, date);
                                                            }}
                                                            minDate={new Date()}
                                                        />
                        </div>
                        {isAddressTime && (
                            <div className="">
                                <>
                                    {doctorAvailability?.availableSlots?.map((availability, index) => (
                                        <>
                                            <div className="d-flex justify-content-start align-items-center">
                                                <Image
                                                    imgUrl={MarkLocationIcon}
                                                    altText="mark location"
                                                    className="me-3"
                                                />
                                                <p className="mb-0 location">{availability.name}</p>
                                            </div>

                                            <div className="justify-content-between margin-y-14 slot slot-scroll">
                                                {availability?.slots.map((time, timeIndex) => (
                                                    <span
                                                        key={timeIndex}
                                                        className={`badge ${selectedTime.location === 'Surgery' && selectedTime.time === time.startTime
                                                            ? 'badge-selected badge-primary'
                                                            : ''
                                                            }`}
                                                        onClick={() => handleSelectTime('Surgery', time.startTime)}
                                                    >
                                                        {time.startTime}
                                                    </span>
                                                ))}
                                            </div>
                                        </>
                                    ))}
                                </>
                            </div>
                        )}

                        <p className="text-danger"><b>{errorMessage}</b></p>
                    </div>
                </div>
            </div>
        </>
    )
};

export default AppointmentSchedule;